//helpers:
import { getData } from '../../dataLib';

import React, { Component } from 'react';
import { connect } from 'react-redux';
//import update from 'immutability-helper';
import { bindActionCreators } from 'redux';
import uuidv4 from 'uuid';
import PropTypes from 'prop-types';

//comopnents:
import NeuriteGrid from '../../components/neurite_grid';
import DatePicker from '../../components/utils/DatePicker';

//actions:
import { navigate, openDialog, hideDialog, loading } from '../../actions';

import { setCentroDia } from '../../actions/centro_dia_actions';

//material ui:
import { withStyles } from '@material-ui/core/styles';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import Button from '@material-ui/core/Button';

import * as config from '../../constants/configuration';
import { ArrowRightSharp } from '@material-ui/icons';

const styles = theme => ({
    root: {
        flexGrow: 1,
    },
    toolbar: {
        display: 'block',
        minHeight: '112px',
    },
    spinnerContainer: {
        width: '95%',
        height: 300,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    spinner: {
        width: '50px !important',
        height: '50px !important',
    },
    containerPair: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: 800,
    },
});

class EntAlbaranHist extends Component {
    constructor(props) {
        super(props);

        let fend = new Date();
        let fini = new Date(
            fend.getFullYear() - 1,
            fend.getMonth(),
            fend.getDate(),
        );
        this.state = {
            albaranList: [],
            fIni: fini.toISOString().slice(0, 10),
            fEnd: fend.toISOString().slice(0, 10),
        };
    }

    refresh(aCentroId, aFIni, aFEnd) {
        let request =
            'DCAlbarans/lista?centro_id=' +
            aCentroId +
            '&f_ini=' +
            aFIni +
            '&f_end=' +
            aFEnd;

        this.props.loading(true);
        getData(
            request,
            response => {
                this.setState({
                    ...this.state,
                    albaranList: response.data.map(p => {
                        return {
                            ...p,
                            ft_fEntrega: p.fEntrega ? new Date(p.fEntrega).toLocaleDateString('es-ES', { year: '2-digit', month: '2-digit', day: '2-digit' }) : '',
                        }
                    }),
                    fIni: aFIni,
                    fEnd: aFEnd,
                });
                this.props.loading(false);
            },
            error => {
                this.props.openDialog(
                    'SimpleMessage',
                    {
                        message: 'ERROR fetching lista albaranes',
                    },
                    'ent_albaran_hist',
                    false,
                    'sm',
                );
                this.props.loading(false);
            },
            this.props.user,
        );
    }

    componentDidMount() {
        if (!this.props.user && config.AUTH) {
            this.props.navigate(''); //go to home page
            return;
        }

        this.refresh(
            this.props.centroId ? this.props.centroId : -1,
            this.state.fIni,
            this.state.fEnd,
        );
    }

    messageDialog = msg => {
        this.props.openDialog(
            'SimpleMessage',
            {
                message: msg,
            },
            uuidv4(),
            false,
            'sm',
        );
    };

    editAlbaran = (albaran) => {
        this.props.openDialog(
            'EditNuevoAlbaran',
            {
                pedido: albaran,
                imenu: "2", // indica que solo es para edicion
                centroId: this.props.centroId,
                okHandler: () => { },
                refreshHandler: () => this.refresh(this.props.centroId, this.state.fIni, this.state.fEnd),
                openDialog: this.props.openDialog,
                centroDescr: albaran.centroDescr,
                user: this.props.user,
                iPerfil: this.props.iPerfil,
                kd: this.props.kd,
            },
            uuidv4(),
            true,
            'md',
        );
    };

    // ddw centros events
    centroSelectList = () => {
        return this.props.centros
            .filter(c => c.activo === 1)
            .map((centro, index) => {
                return (
                    <option key={centro.id} value={centro.id}>
                        {centro.centro}
                    </option>
                );
            });
    };

    handleChangeSelectCentro = event => {
        this.refresh(
            event.target.value ? event.target.value : -1,
            this.state.fIni,
            this.state.fEnd,
        );

        if (event.target.value)
            this.props.setCentroDia(event.target.value, undefined, false);
    };

    handleValueChange = (event, field) => {
        this.setState({ ...this.state, [field]: event.target.value });
    };
    handleValueChangeDate = (event, field) => {
        this.setState({ ...this.state, [field]: event });
    };

    render() {
        const { classes } = this.props;


        var gridcols = [
            {
                key: 'ft_fEntrega',
                name: 'Fecha alta',
                tooltip: 'Fecha del albarán',
                editable: false,
                dragable: false,
                width: 70,
            },
        ];

        if ([0, 4, 5, 16, 17, 20].includes(this.props.iPerfil) && this.props.kd === undefined)
            gridcols = gridcols.concat([
                {
                    key: 'centroDescr',
                    name: 'Centro',
                    editable: false,
                    dragable: false,
                    width: 100,
                },
            ]);

        gridcols = gridcols.concat([
            {
                key: 'refPedido',
                name: 'Ref.Ped.',
                tooltip: 'Referencia del pedido',
                editable: false,
                dragable: false,
                width: 50,
            },
            {
                key: 'proveedorDescr',
                name: 'Proveedor',
                editable: false,
                dragable: false,
                width: 190,
            },
            {
                key: 'obsv',
                name: 'Prov. Inicial / Obsv',
                tooltip: 'Proveedor inicial u observaciones',
                editable: false,
                dragable: false,
                width: 140,
            },
            {
                key: 'refAlbaran',
                name: 'Ref.Alb.',
                tooltip: 'Referencia del albarán',
                editable: false,
                dragable: false,
                width: 100,
            },
            {
                key: 'iTipoAlbaran',
                name: 'Dev?',
                tooltip: 'Es una devolución?',
                editable: false,
                dragable: false,
                width: 40,
                type: 'bool',
            },
            {
                key: 'obsvAlb',
                name: 'Obsv.',
                tooltip: 'Observaciones del albarán',
                editable: false,
                dragable: false,
                width: 150,
            },
            {
                key: 'total',
                name: 'Total €',
                tooltip: 'Valor total del albarán',
                type: 'float',
                editable: false,
                dragable: false,
                width: 70,
            },
        ]);

        return (
            <div className={classes.root}>
                <div className={classes.toolbar} />

                <div
                    style={{ marginBottom: 20, marginLeft: 20 }}
                    className={classes.containerPair}
                >
                    {this.props.centros &&
                        [0, 4, 5, 16, 17, 20].includes(this.props.iPerfil) &&
                        this.props.kd === undefined ? (
                            <FormControl className={classes.formControl}>
                                <InputLabel htmlFor="pedido-placeholder">
                                    Centro
                                </InputLabel>
                                <Select
                                    native
                                    value={this.props.centroId}
                                    onChange={event =>
                                        this.handleChangeSelectCentro(event)
                                    }
                                >
                                    {this.props.centros.find(
                                        c => c.id === this.props.centroId,
                                    ) === undefined ? (
                                            <option key={'centro_0'} value={0}>
                                                {'Seleccione un centro'}
                                            </option>
                                        ) : (
                                            ''
                                        )}
                                    {this.centroSelectList()}
                                </Select>
                            </FormControl>
                        ) : (
                            ''
                        )}

                    <FormControl className={classes.formControl}>
                        <DatePicker
                            label={'Fecha Inicio'}
                            value={this.state.fIni}
                            onChange={event => {
                                if (event && !isNaN(event)) {
                                    const d = new Date(Date.UTC(event.getFullYear(), event.getMonth(), event.getDate()));
                                    this.handleValueChangeDate(d.toISOString().slice(0, 10), 'fIni')
                                }
                            }}
                            onKeyPress={event => {
                                if (event.key === 'Enter') {
                                    this.handleValueChangeDate(
                                        event,
                                        'fIni',
                                    );
                                    this.refresh(
                                        this.props.centroId,
                                        event.target.value,
                                        this.state.fEnd,
                                    );
                                }
                            }}
                        />
                    </FormControl>

                    <FormControl className={classes.formControl}>
                        <DatePicker
                            label={'Fecha Fin'}
                            value={this.state.fEnd}
                            onChange={event => {
                                if (event && !isNaN(event)) {
                                    const d = new Date(Date.UTC(event.getFullYear(), event.getMonth(), event.getDate()));
                                    this.handleValueChangeDate(d.toISOString().slice(0, 10), 'fEnd')
                                }
                            }}
                            onKeyPress={event => {
                                if (event.key === 'Enter') {
                                    this.handleValueChangeDate(
                                        event,
                                        'fEnd',
                                    );
                                    this.refresh(
                                        this.props.centroId,
                                        this.state.fIni,
                                        event.target.value,
                                    );
                                }
                            }}
                        />
                    </FormControl>

                    <Button
                        variant="contained"
                        color="secondary"
                        onClick={() => {
                            this.refresh(
                                this.props.centroId,
                                this.state.fIni,
                                this.state.fEnd,
                            );
                        }}
                    >
                        Buscar
                        </Button>
                </div>

                <div style={{ marginBottom: 20 }}>
                    {this.state.albaranList ? (
                        <NeuriteGrid
                        id="e_a_h"
                            columns={gridcols}
                            rows={this.state.albaranList}
                            height={500}
                            buttonEdit={true}
                            buttonDelete={false}
                            buttonNew={false}
                            onEditClick={this.editAlbaran}
                            enableFilter={true}
                        />
                    ) : (
                            ''
                        )}
                </div>
            </div>
        );

    }
}

EntAlbaranHist.propTypes = {
    //state
    user: PropTypes.object.isRequired,
    navigate: PropTypes.func.isRequired,
    openDialog: PropTypes.func.isRequired,
    hideDialog: PropTypes.func.isRequired,
    // user ddw
    centros: PropTypes.array.isRequired,
    centroId: PropTypes.number.isRequired,
    centroDescr: PropTypes.string.isRequired,
};

function mapStateToProps(state) {
    return {
        user: state.oidc.user,
        centros: state.centros.centros,
        centroId: state.centroDiaSelected.centro.id,
        centroDescr: state.centroDiaSelected.centro.centro, // es la descripción del centro¡?
        iPerfil: state.userProfile.selectedCentroProfile ? state.userProfile.selectedCentroProfile.iPerfil : 0,
        kd : state.userProfile.kd,
    };
}

function mapDispathToProps(dispatch) {
    return bindActionCreators(
        {
            navigate,
            setCentroDia,
            openDialog,
            hideDialog,
            loading
        },
        dispatch,
    );
}

export default connect(
    mapStateToProps,
    mapDispathToProps,
)(withStyles(styles, { withTheme: true })(EntAlbaranHist));
